// Style native legacy Backstage headers without hiding their content or actions.
const headerBase = {
  header: {
    backgroundImage: 'none' as const,
    boxShadow: 'none' as const,
    color: 'var(--ns-color-fg-default)',
  },
  subtitle: {
    color: 'var(--ns-color-fg-subtle)',
  },
  title: {
    color: 'var(--ns-color-fg-default)',
  },
  type: {
    color: 'var(--ns-color-fg-subtle)',
  },
};

export const BackstageHeaderLightOverrides = headerBase;
export const BackstageHeaderDarkOverrides = headerBase;
